import { Component, Input, OnInit } from '@angular/core';
import { GrundstueckId } from '../../core/gb-api';
import { Observable } from 'rxjs';
import { CapAlertComponent } from '../../core/extension/exceptions/cap-alert.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-oereb-wrapper',
  templateUrl: './oereb-wrapper.component.html',
  imports: [CapAlertComponent, AsyncPipe, TranslatePipe]
})
export class OerebWrapperComponent implements OnInit {
  @Input()
  hasData: Observable<boolean>;
  @Input()
  stockwerkOrMiteigentum: boolean;
  @Input()
  gsId: GrundstueckId;
  @Input()
  oerebServiceNichtVerfuegbar: boolean;

  constructor() {}

  ngOnInit() {}
}
